import React from "react";
import "./DashboardScreen.css";
import { useNavigate } from "react-router-dom";
import { GoChevronRight, GoArrowLeft } from "react-icons/go";
import { FiExternalLink } from "react-icons/fi";
import Navbar from "../../../common/components/HeaderOpsPage/Navbar";
import Body from "../../../common/components/Body/Body";

// Executive Dashboard landing page.
//
// The MH Insights dashboard (Azure Container Apps) sends
// `X-Frame-Options: DENY`, so we can't embed it as an iframe. Instead, the
// landing-page tile opens it directly in a new tab (see LandingPage.js).
// This page is the fallback for anyone who hits /dashboardPage by URL —
// it shows a clear "Open Dashboard" call-to-action.
const DashboardScreen = () => {
  const navigate = useNavigate();
  const dashboardUrl = process.env.REACT_APP_INSIGHTS_DASHBOARD_URL;

  return (
    <>
      <Navbar />
      <Body className={"wrapper"}>
        <div className="dashboard-main--container main-component-container">
          <div className="row">
            <div className="col-6">
              <p className="insight-breadCrum m-0">
                <GoArrowLeft
                  className="buttonFeature pb-1"
                  size={22}
                  onClick={() => navigate("/landing")}
                />
                <span onClick={() => navigate("/landing")}>Home</span>
                <GoChevronRight size={18} />
                <span>
                  <u>Executive Dashboard</u>
                </span>
              </p>
            </div>
          </div>

          <div
            style={{
              marginTop: 80,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 16,
              textAlign: "center",
            }}
          >
            <h2 style={{ fontSize: 22, fontWeight: 700, color: "#0f172a", margin: 0 }}>
              Executive Dashboard
            </h2>
            <p style={{ color: "#64748b", maxWidth: 560, margin: 0 }}>
              The dashboard opens in a new tab — it can't be embedded directly
              in this page due to its security headers.
            </p>
            {dashboardUrl ? (
              <a
                href={dashboardUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  marginTop: 8,
                  padding: "12px 24px",
                  background: "#1e3a8a",
                  color: "#fff",
                  fontSize: 15,
                  fontWeight: 600,
                  borderRadius: 8,
                  textDecoration: "none",
                }}
              >
                Open Dashboard
                <FiExternalLink size={16} />
              </a>
            ) : (
              <p style={{ color: "#ef4444", marginTop: 8 }}>
                Dashboard URL not configured. Set{" "}
                <code>REACT_APP_INSIGHTS_DASHBOARD_URL</code> in the env file.
              </p>
            )}
          </div>
        </div>
      </Body>
    </>
  );
};

export default DashboardScreen;
